
import React,  { useEffect, useState, useRef } from "react";
import { Grid } from "@mui/material";
import { connect } from 'react-redux';

// custom utils
import { DrawChart } from "../charts/TVChart";
import { TopBar } from "../bars/StockWatchBars";
import { useWindowDimensions } from "../pages/Utils";

// local json files
import dows from "../data/dow.json";
import nasdaqs from "../data/nasdaq.json";
import sandps from "../data/s&p500.json";
import sandpSectors from "../data/spysectors.json";
import coins from "../data/coins.json";
import russell from "../data/russell_1000.json";
import arkk from "../data/arkk.json";

const StockWatch = ({ navbarSize, topbarSize, interval, darkMode }) => {

    const dowItems = dows.map(d => d.Ticker);
    const nasdaqItems = nasdaqs.map(d => d.Ticker);
    const sandpItems = sandps.map(d => d.Ticker);
    const russellItems = russell.map(d => d.Ticker);
    const arkkItems = arkk.map(d => d.Ticker);
    
    const coinList = coins.slice(0, 250).filter(coin => coin.Stablecoin === false).map(coin => coin.Ticker);
    
    
    const sectorNames = sandpSectors.map(d => d.Ticker+' ('+d.Name+')');
    // console.log(sectorNames);

    const indexList = ['S&P 500 Components', 'NDQ 100 Components', 'DOW 30 Components', 'Russell 1000 Components', 'ARKK Components', 'Cryptocurrency Coins', ...sectorNames];

    // A map to associate list names with their corresponding data arrays.
    // This simplifies the logic in handleWatchlist.
    const listDataMap = {
        'S&P 500 Components': sandpItems,
        'NDQ 100 Components': nasdaqItems,
        'DOW 30 Components': dowItems,
        'Russell 1000 Components': russellItems,
        'Cryptocurrency Coins': coinList,
        'ARKK Components': arkkItems,
    };


    // handle list of index
    const [selectList, setSelectList] = useState('DOW 30 Components');

    const [watchlist, setWatchlist] = useState(dowItems);

    const [symbol, setSymbol] = useState('AAPL');

    const handleWatchlist = (e) => {
        const listSelected = e.target.value;
        let newItems = listDataMap[listSelected];

        if (!newItems && sectorNames.includes(listSelected)) {
            const idx = sectorNames.indexOf(listSelected);
            newItems = sandpSectors[idx]['Comps'].map(v => v.Ticker);
        }

        if (newItems) {
            setWatchlist(newItems);
            setSelectList(listSelected);
            setSymbol(newItems[0] || '');
        }
    }

    // Effect to focus the TradingView widget when the list selection changes.
    useEffect(() => {
        const focusTimeout = setTimeout(() => {
            const widgetContainer = document.getElementById('watchlist');
            const iframe = widgetContainer?.querySelector('iframe');
            iframe?.focus({ preventScroll: true });
        }, 500); // 500ms delay.

        return () => clearTimeout(focusTimeout);
    }, [selectList]);

    // setting chart dimensions *** potential to improve ***
    const topHeight = navbarSize + topbarSize + 10;
    const chartWidth = useWindowDimensions().width;
    const chartHeight = useWindowDimensions().height;


    return (
        <div>
        <div>
        <TopBar
            indexList={ indexList }
            selectList={ selectList }
            handleWatchlist={ handleWatchlist }
        >
        </TopBar>
        </div>

        <Grid container sx={{
            minHeight: chartHeight - topHeight,
            backgroundColor: '#131722',
        }}>
            <Grid item xs={12}>
                <DrawChart
                    width={chartWidth - 10}
                    height={chartHeight - topHeight}
                    symbol={symbol}
                    watchlist={ watchlist }
                    interval={ interval }
                    darkMode={ darkMode }
                ></DrawChart>
            </Grid>
        </Grid>
        </div>
    )
};

const mapStateToProps = (state) => ({
    navbarSize: state.barSize.navbarSize,
    topbarSize: state.barSize.topbarSize,
    interval: state.settings.interval,
    darkMode: state.settings.darkMode,
});

export default connect( mapStateToProps ) (StockWatch);
